import React, { useState } from 'react';
import { Typography } from 'antd';
import DataCollSelectionByYear from './DataCollSelectionByYear';
import PortfolioData from './PortfolioData';

interface PortfolioDataDashboardProps {
  client: { id: string; name?: string; token: string; permissions: string[] };
  title?: string;
}

const PortfolioDataDashboard: React.FC<PortfolioDataDashboardProps> = ({ client, title }) => {
  const [dataCollYear, setDataCollYear] = useState<number>();

  return client === undefined ? (
    <div>Please select a client.</div>
  ) : (
    <>
      <Typography.Title level={1}>{title || `Portfoliodaten für ${client.name}`}</Typography.Title>
      <DataCollSelectionByYear
        dataCollYear={dataCollYear}
        setDataCollYear={setDataCollYear}
        client={client}
      />
      {dataCollYear && <PortfolioData client={client} dataCollYear={dataCollYear} />}
    </>
  );
};

export default PortfolioDataDashboard;
